<template lang="pug">
.year-container
	h2.year-title {{ title }}
	.classes-container
		YourPlanColumnItem(
			v-for="( section, i) in sections"
			class="class"
			:key='i'
			:section="section"
			@click="$emit('selectSection', i)"
		)
	.total-wrapper
		p.total {{ `${this.numCoursesRequired} Courses Required` }}
</template>

<script>
import YourPlanColumnItem from '@/components/YourPlanColumnItem';

export default {
  name       : 'your-plan-column',
  components : {
    YourPlanColumnItem,
  },

  props : {
    title    : String,
    sections : {
      type : Array,
    }
  },

  computed : {
    numCoursesRequired() {
      return ['freshman', 'sophomore'].includes( this.title ) ? 7 : 5;
    }
  }
};
</script>

<style lang="scss" scoped>
.year-container {
	.year-title {
		margin-bottom: 8px;
		margin-left: 15px;
		font-size: 22px;
		font-weight: 600;
		line-height: 19px;
		letter-spacing: -0.02em;
		color: #3654BD;
		text-transform: capitalize;
	}

	.classes-container {
		.class {
			margin-bottom: 12px;
		}
	}

	.total-wrapper {
		text-align: center;
		padding-top: 4px;
		font-size: 14px;
		line-height: 10px;
		letter-spacing: -0.03em;
		color: $ypText;
	}
}

@media print {
	@page { size: landscape; }

	.year-container {
		.year-title {
			font-size: 18px;
		}

		.total-wrapper {
			.total {
				font-size: 12px;
			}
		}
	}
}
</style>
